import { Component } from '@angular/core';

@Component({
  selector: 'ddw-sandbox-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ddw-portal-sandbox';
}
